export default __webpack_public_path__ + "static/media/185.450a0177.jpg";